export default __webpack_public_path__ + "static/media/water-wave.2ebff115.svg";